<div class="first-mfa-setup-container">
  <div class="first-mfa-setup-card">
    <div class="first-mfa-setup-header">
      <div class="logo-container mb-3">
        <img src="assets/alt_logo.png" alt="Company Logo" class="company-logo">
      </div>
      <h4>First-Time Login Setup</h4>
      <p>Secure your account with Two-Factor Authentication</p>
    </div>

    <div class="first-mfa-setup-body">
      <div class="first-mfa-user-info">
        <p class="mb-1">Account:</p>
        <p class="fw-bold mb-0">{{ userEmail }}</p>
      </div>

      <!-- Welcome Message -->
      @if (!isSetupComplete && !setupDetails) {
        <div class="welcome-section">
          <div class="mb-4">
            <i class="bi bi-shield-lock-fill" style="font-size: 4rem; color: var(--bs-primary);"></i>
          </div>
          <h5 class="mb-4">Welcome to Your First Login!</h5>
          <p>For security purposes, you are required to set up Two-Factor Authentication (MFA).</p>
          <p>This will add an extra layer of protection to your account.</p>
          <div class="d-grid gap-2">
            <button class="mfa-btn mfa-btn-primary mfa-btn-lg" (click)="initiateMfaSetup()">
              <i class="bi bi-shield-fill-check me-2"></i>Begin MFA Setup
            </button>
          </div>
        </div>
      }

      <!-- MFA Setup Form -->
      @if (!isSetupComplete && setupDetails) {
        <div class="mfa-setup-section">
          <div class="mfa-setup-header">
            <h5>Set Up Two-Factor Authentication</h5>
            <p>Follow these steps to secure your account</p>
          </div>
          <div class="row">
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="mfa-qr-container">
                <p class="mb-3">Step 1: Scan this QR code</p>
                <img [src]="setupDetails.qrCode" alt="MFA QR Code" class="mfa-qr-code img-fluid">
                <div class="mfa-secret-container mt-4">
                  <p class="mfa-secret-label mb-2">Can't scan the QR code?</p>
                  <p class="mb-1">Enter this key manually:</p>
                  <code class="mfa-secret-key">{{ setupDetails.secret }}</code>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <div class="mfa-instructions mb-4">
                <h6 class="mb-2">How to complete setup:</h6>
                <ol class="mb-0">
                  <li>Install an authenticator app (Google Authenticator, Authy, etc.)</li>
                  <li>Scan the QR code or enter the key manually</li>
                  <li>Enter the 6-digit code generated by your app below</li>
                  <li>Click "Verify & Enable MFA" to complete setup</li>
                </ol>
              </div>
              <div class="mfa-form-group">
                <label for="otp" class="mfa-form-label">Step 2: Enter Verification Code</label>
                <input
                  type="text"
                  id="otp"
                  class="mfa-form-control"
                  [(ngModel)]="otp"
                  (input)="onOtpInput($event)"
                  placeholder="123456"
                  maxlength="6"
                  autocomplete="off"
                  autofocus>
                <div class="mfa-form-text">
                  Enter the 6-digit code from your authenticator app
                </div>
              </div>
              @if (errorMessage) {
                <div class="mfa-alert mfa-alert-danger">
                  {{ errorMessage }}
                </div>
              }
              <div class="mfa-btn-group mt-4">
                <button
                  class="mfa-btn mfa-btn-success"
                  (click)="verifyAndEnableMfa()"
                  [disabled]="isLoading || !otp || otp.length < 6">
                  @if (isLoading) {
                    <span class="spinner-border spinner-border-sm mfa-spinner" role="status" aria-hidden="true"></span>
                  }
                  @if (!isLoading) {
                    <i class="bi bi-check-circle-fill me-2"></i>
                  }
                  Verify & Enable MFA
                </button>
                <button class="mfa-btn mfa-btn-secondary" (click)="cancelSetup()">
                  <i class="bi bi-x-circle-fill me-2"></i>Cancel Setup
                </button>
              </div>
            </div>
          </div>
        </div>
      }

      <!-- Setup Complete -->
      @if (isSetupComplete) {
        <div class="setup-complete-section">
          <div class="setup-complete-icon">
            <i class="bi bi-check-circle-fill"></i>
          </div>
          <h5>MFA Setup Complete!</h5>
          <p>Your account is now secured with Two-Factor Authentication.</p>
          <p>From now on, you'll need to enter a code from your authenticator app when logging in.</p>
          <div class="d-grid gap-2">
            <button class="mfa-btn mfa-btn-primary mfa-btn-lg" (click)="continueToDashboard()">
              <i class="bi bi-speedometer2 me-2"></i>Continue to Dashboard
            </button>
          </div>
        </div>
      }
    </div>

    <div class="first-mfa-setup-footer">
      <small>
        Need help? Contact your administrator.
      </small>
    </div>
  </div>
</div>